export class AppError extends Error {
  constructor(
    public code: string,
    message: string,
    public statusCode: number = 500,
    public messageTh?: string,
    public suggestion?: string,
  ) {
    super(message)
    this.name = 'AppError'
  }
}

export class ValidationError extends AppError {
  constructor(
    code: string,
    message: string,
    messageTh: string,
    public field?: string,
    suggestion?: string,
  ) {
    super(code, message, 400, messageTh, suggestion)
    this.name = 'ValidationError'
  }
}

export class AuthError extends AppError {
  constructor(code: string, message: string, messageTh: string, suggestion?: string) {
    super(code, message, 401, messageTh, suggestion)
    this.name = 'AuthError'
  }
}

export class ForbiddenError extends AppError {
  constructor(code: string, message: string, messageTh: string, suggestion?: string) {
    super(code, message, 403, messageTh, suggestion)
    this.name = 'ForbiddenError'
  }
}

export class NotFoundError extends AppError {
  constructor(code: string, message: string, messageTh: string) {
    super(code, message, 404, messageTh)
    this.name = 'NotFoundError'
  }
}

export const CommonErrors = {
  UNAUTHORIZED: new AuthError(
    'AUTH_UNAUTHORIZED',
    'Authentication required',
    'กรุณาเข้าสู่ระบบ',
    'กรุณาเข้าสู่ระบบด้วย LINE',
  ),

  SESSION_EXPIRED: new AuthError(
    'AUTH_SESSION_EXPIRED',
    'Session has expired',
    'เซสชันหมดอายุ',
    'กรุณาเข้าสู่ระบบใหม่',
  ),

  FORBIDDEN: new ForbiddenError(
    'AUTH_FORBIDDEN',
    'Insufficient permissions',
    'ไม่มีสิทธิ์เข้าถึง',
    'กรุณาติดต่อผู้ดูแลระบบ',
  ),

  STUDENT_NOT_FOUND: new NotFoundError(
    'STUDENT_NOT_FOUND',
    'Student not found',
    'ไม่พบข้อมูลนักเรียน',
  ),

  CLASSROOM_NOT_FOUND: new NotFoundError(
    'CLASSROOM_NOT_FOUND',
    'Classroom not found',
    'ไม่พบข้อมูลห้องเรียน',
  ),
}
